// Import version module FIRST - sets window.__FIINDER_WIDGET_VERSION__ as a side effect
import "./lib/version";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import LandingApp from "./LandingApp";
import indexCss from "./index.css?inline";
import landingPageCss from "./landing-page.css?inline";
import { setupDevConfig } from "./dev-config";

const LANDING_STYLES_ATTRIBUTE = "data-fiinder-landing-styles";

declare global {
  interface Window {
    FIINDER_ROOT_ID?: string;
  }
}

function ensureLandingStyles() {
  if (typeof document === "undefined") return;
  if (document.head.querySelector(`style[${LANDING_STYLES_ATTRIBUTE}]`)) {
    return;
  }

  const style = document.createElement("style");
  style.setAttribute(LANDING_STYLES_ATTRIBUTE, "true");
  style.textContent = `${indexCss}\n${landingPageCss}`;
  document.head.appendChild(style);
}

function resolveMountNode() {
  const preferredRootId =
    typeof window !== "undefined" && window.FIINDER_ROOT_ID
      ? window.FIINDER_ROOT_ID.trim()
      : "root";

  const existingRoot = document.getElementById(preferredRootId);
  if (existingRoot) return existingRoot;

  const fallbackRoot = document.createElement("div");
  fallbackRoot.id = preferredRootId || "root";
  document.body.appendChild(fallbackRoot);
  return fallbackRoot;
}

// Setup dev config from Vite env vars (only sets if not already defined)
setupDevConfig();
ensureLandingStyles();

createRoot(resolveMountNode()).render(
  <StrictMode>
    <LandingApp />
  </StrictMode>
);
